export default __webpack_public_path__ + "static/media/Blog2_1.0408640b.jpg";